import React, { HTMLAttributes, forwardRef, ReactChild } from "react";
// 1. Import the new CSS file
import "./loaderText.css";

// UI props interface
export interface LoaderTextUIProps {
    children: ReactChild;
}

// Full props type
export type LoaderTextProps = HTMLAttributes<HTMLDivElement> & LoaderTextUIProps;

/**
 * Loader text is variation of header used below the loader icon
 */
const LoaderText = forwardRef<HTMLDivElement, LoaderTextProps>(
    ({ className, children, ...other }, ref) => {
        
        // 2. Build the class list
        const classNames = [
            "loader-text", // Base class
            className,     // Any classes passed from the parent
        ]
            .filter(Boolean)
            .join(" ");

        // 3. Render the simple div
        return (
            <div ref={ref} className={classNames} {...other}>
                {children}
            </div>
        );
    }
);

LoaderText.displayName = "LoaderText";

export default LoaderText;
